"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityType = void 0;
var EntityType;
(function (EntityType) {
    EntityType[EntityType["REGION_ENTITY"] = 0] = "REGION_ENTITY";
    EntityType[EntityType["CLIENT_ENTITY"] = 1] = "CLIENT_ENTITY";
    EntityType[EntityType["CLIENT_ONLY_ENTITY"] = 2] = "CLIENT_ONLY_ENTITY";
})(EntityType = exports.EntityType || (exports.EntityType = {}));
//# sourceMappingURL=EntityManifest.js.map